import React, { useState, useEffect } from 'react';
import { toAbsoluteUrl } from '../../helpers';
import { sha256 } from 'js-sha256';
import { useAuth } from '../../../app/modules/auth';

interface AccountAvatarImageProps {
  size: number;
}

const AccountAvatarImage: React.FC<AccountAvatarImageProps> = ({ size }) => {
  const [AccountAvatarImageUrl, SetAccountAvatarImageUrl] = useState<string>('');
  const { currentUser } = useAuth()

  useEffect(() => {
    if (currentUser?.avatar_url) {
      // Wenn avatarUrl vorhanden ist, verwenden wir diese URL
      SetAccountAvatarImageUrl(currentUser?.avatar_url);
    } else if (currentUser?.email) {
      // Wenn avatarUrl null ist, versuchen wir, das Bild von Gravatar zu laden
      try {
        const trimmedEmail = currentUser.email.trim().toLowerCase();
        const hash = sha256(trimmedEmail);
        const gravatarUrl = `https://www.gravatar.com/avatar/${hash}?s=${size}&r=pg&d=identicon`;
        const img: HTMLImageElement = new Image();
        img.src = gravatarUrl;
        img.onload = () => SetAccountAvatarImageUrl(gravatarUrl);
        img.onerror = () => SetAccountAvatarImageUrl('/media/avatars/blank.png'); // Fallback URL
      } catch (error) {
        console.error('Error generating Gravatar URL:', error);
      }
    }
  }, [currentUser?.avatar_url, currentUser?.email, size]);

  return (
    <img src={AccountAvatarImageUrl || toAbsoluteUrl('/media/avatars/blank.png')} alt='User Avatar' />
  );
};

export default AccountAvatarImage;